import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { OrderTotalValueComponent } from '@component/OrderTotalValueComponent';
import type { AppState } from '@app/react/reducer';
import { ArrowType, OrderType, FULL, SEMI } from '@app/react/const/type';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import { convertShippingDate } from '@app/react/common/convertShippingDate';

const selectPrice = (state: AppState): number => state.price.price;

const selectUnitName = (state: AppState): string => state.customize.unit?.name ?? '未選択';

const buildSelectArrowlength = (state: AppState) => {
    const alAdjust = state.customize.arrowlengthAdjust;
    if (!alAdjust) {
        return '矢尺調整なし';
    }

    const al = state.customize.arrowlength?.name ?? null;
    if (al === null) {
        return '矢尺未選択';
    }

    return `矢尺${al}`;
};

const buildSelectShippingDate = (
    arrowType: ArrowType,
    orderType: OrderType,
) => (state: AppState): string => {
    const { full: f, semi: s } = convertShippingDate(state.shippingDate, arrowType);
    if (orderType === FULL) {
        return f ?? '...';
    }
    if (orderType === SEMI) {
        return s ?? '...';
    }

    return '...';
};

export const OrderTotalValueContainer: FC = () => {
    const { arrowType, orderType } = useOrderPathParams();

    const price = useSelector(selectPrice);
    const unitName = useSelector(selectUnitName);
    const alName = useSelector(buildSelectArrowlength);
    const shippingDate = useSelector(buildSelectShippingDate(arrowType, orderType));

    return (
        <OrderTotalValueComponent
            price={price}
            arrowType={arrowType}
            unitName={unitName}
            arrowlengthName={alName}
            shipDate={shippingDate}
        />
    );
};
